import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'

export const rowText = styled.div`
  color: 'rgba(0, 0, 0, 1)' 
  font-weight= '400';
  font-size=15px
`

export const CompanyNameContainar = styled.div`
  flex-direction: row;
  display: flex;
  gap: 10px;
  align-items: center;
    text-overflow: ${props => (props.ellipse ? 'ellipsis' : 'unset')};
`
export const Filtertable = styled.div`
  display: flex;
  margin: 0px 25px;
  margin-top: 25px;
  border-right: 1.5px #e4e7ea solid;
  width: 18.2%;
  height: inherit;
`

export const CorporateMasterDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 142px);
  overflow: scroll;
  padding-right: 10px;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 50px;
  }

  `

  export const TabCount = styled(Flex)`
  width: 2rem;
  height: 1.3rem;
  line-height: 1.3rem;
  border-radius: 0.5rem;
  background-color: ${COLORS.PRIMARY};
  color: ${COLORS.WHITE};
  justify-content: center;
  font-size: 8px;
  font-weight: 600;
`
export const HeaderBold = styled.div`
font-size: 15px;
font-weight: 600;
line-height: 18px;
color: #010E30;
`

export const SubHeader = styled.div`
font-size: 14px;
font-weight: 400;
line-height: 20px;
color: #999FAC;
padding-bottom: 10px;
padding-top:2px;
`

export const TitleText = styled.div`
font-size: 16px;
font-weight: 700;
line-height: 20px;
color: #000000;
padding-bottom: 5px;
`
export const SubTitleText = styled.div`
font-size: 14px;
font-weight: 400;
line-height: 20px;
color: #000000;
padding-bottom: 10px;
text-transform: ${props => (props.transform ? 'capitalize' : 'none')};
 span {
    color: #3249D7; 
    cursor: pointer;
  }
`

export const PaddingTop =  styled.div`
padding-top: 8px;
`
export const NavigateSpan = styled.span`
cursor: pointer;
`